import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteFreightClaimAttachmentsCall,
  postUpdateWarehouseTransfer,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";
import { UploadAttachmentFile } from "../CreateInventoryAdjustment/interface";

export const editWarehouseTransfer = createAsyncThunk(
  "editWarehouseTransfer",
  (payload: any) => postUpdateWarehouseTransfer(payload)
);

export const editWarehouseTransferUploadAttachments = createAsyncThunk(
  "editWarehouseTransferUploadAttachments",
  (fcUploadAttachmentPayload: UploadAttachmentFile) =>
    uploadFreightClaimAttachmentsCall(fcUploadAttachmentPayload)
);

export const deleteWarehouseTransferAttachments = createAsyncThunk(
  "deleteWarehouseTransferAttachments",
  (filePath: string) => {
    deleteFreightClaimAttachmentsCall(filePath);
  }
);

export const initialState: any = {
  notes: "",
  attachments: [],
  blockNavigation: true,
  loading: false,
  deletedAttachmentPaths: []
};

const editWarehouseTransferSlice = createSlice({
  name: "editWarehouseTransfer",
  initialState,
  reducers: {
    updateWarehouseTransferNavigationBlocking(state: any, action: any) {
      state.blockNavigation = action.payload;
    },
    updateWarehouseTransferNotes(state: any, action: any) {
      const notes = action.payload;
      state.notes = notes;
    },
    updateWarehouseTransferAttachment(
      state: any,
      action: {
        payload: { fileName: string; fileURL: string; fileType: string };
      }
    ) {
      state.attachments.push(action.payload);
    },
    removeWarehouseTransferAttachment(state: any, action: { payload: number }) {
      const filterAttachments = state.attachments.filter(
        (_item: any, itemIndex: number) => itemIndex !== action?.payload
      );

      const deletedAttachment = state.attachments.find(
        (_item: any, itemIndex: number) => itemIndex === action?.payload
      );
      state.deletedAttachmentPaths.push(
        deletedAttachment?.fileUrl ?? deletedAttachment?.fileURL
      );

      state.attachments = filterAttachments;
    },
    resetWarehouseTransfer() {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(editWarehouseTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(editWarehouseTransfer.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editWarehouseTransfer.rejected, (state) => {
        state.loading = false;
      });
  }
});

export const {
  updateWarehouseTransferNotes,
  updateWarehouseTransferNavigationBlocking,
  updateWarehouseTransferAttachment,
  removeWarehouseTransferAttachment,
  resetWarehouseTransfer
} = editWarehouseTransferSlice.actions;

export const selectBlockWarehouseTransferNavigation = (state: any) =>
  state.editWarehouseTransfer.blockNavigation;

export const selectWarehouseTransferNotes = (state: any) =>
  state.editWarehouseTransfer.notes;

export const selectWarehouseTransferAttachments = (state: any) =>
  state.editWarehouseTransfer?.attachments;

export default editWarehouseTransferSlice.reducer;
